import type * as React from 'react';
import { Heading } from '../../components/Heading/Heading';
import { useSelector } from 'react-redux';
import { selectSeo } from '../../selectors/layoutsCatalog';

export const HeadingContainer = (): React.JSX.Element => {
  const seo = useSelector(selectSeo);

  return <Heading title={seo.h1} url={seo.listingUrl} subtitle={seo.subtitle} description={seo.text} />;
};
